/*
 * @Author: 
 * @Description: 
 * @Date: 2021-05-07 17:12:58
 */
import * as services from '../service';
import { getMergedConfigs} from '../utils/app';
import { ConfigHandler, Env, MicroAppEntryConfigs } from './../interfaces';


export const getConfigFromLocalstorage = (coreId: number): MicroAppEntryConfigs =>{
    let config = null;
    try {
        const str = window.localStorage.getItem(`${window.location.host}_${coreId}_dolly`);
        if (str) {
            config = JSON.parse(str);
        }
    } catch (e) {
        // log
    }
    return config;
}

export const getMicroAppConfig = async ({env, coreId, identifyKey, customerConfig, configHandler } : {
    env: Env, coreId: number, customerConfig?: MicroAppEntryConfigs, identifyKey?: string; configHandler?: ConfigHandler
}): Promise<MicroAppEntryConfigs> => {
    if (env === "development" && customerConfig) {
        if (configHandler) {
            const handled = configHandler(customerConfig); 
            return handled || customerConfig;
        }
        return customerConfig;
    }
    // env: production | test | beta (able to support);
    try {
        // default from Api
        const { data } = await services.getAppInfos(coreId, env, identifyKey);
        if (data?.length === 0) {
            console.warn('[DOLLY ERROR] can not get available MicroApp config, 返回data为空')
            return {};
            // throw new Error('[DOLLY ERROR] can not get available MicroApp config');
        }
        console.info(`[DOLLY INFO] Use MicroApp config from API`)
        return getMergedConfigs({}, data, configHandler);
    } catch (e) {
        // try to get config from localstorage when api failed
        let config = getConfigFromLocalstorage(coreId);
        if (!config) {
            // otherwise use cdn backups data
            const dataFromCdn = await services.getAppInfosFromCdn(coreId, env);
            config = getMergedConfigs({}, dataFromCdn, configHandler);
            console.info(`[DOLLY INFO] Use MicroApp config from CDN`)
        } else {
            console.info(`[DOLLY INFO] Use MicroApp config from LS`)
        }
        return config;
    }
}

 